import axios from 'axios';

import IAnalyticsJobSearchFilterDTO from '../../../types/IAnalyticsJobSearchFilterDTO';
import { IJobCandidateInteraction } from '../../CandidateSearchService';
import { IJobSearchFilterDTO } from '../../JobSearchService';
import { ITaskSearchParam } from '../../TaskService';
import IDashboardAnalyticsParams from '../types/IDashboardAnalyticsParams';
import IEmailAnalyticsFilter from '../types/IEmailAnalyticsFilter';
import IKibanaAnalyticsSettingsPayload from '../types/IKibanaAnalyticsSettingsPayload';
import ILoginLogoutAnalyticsDTo from '../types/ILoginLogoutAnalyticsDTO';
import ISubmissionAnalyticsSearchFilterQuery from '../types/ISubmissionAnalyticsSearchFilterQuery';

const url = 'wsreporting/api/';

export const getSubmissionTrendData = (query: ISubmissionAnalyticsSearchFilterQuery) =>
  axios.post(`${url}real-time-submission-trend`, query);

export const getSubmissionCreatedOrUpdated = (query: ISubmissionAnalyticsSearchFilterQuery) =>
  axios.post(`${url}real-time-submission-created-or-updated-by`, query);

export const getSubmissionCreatedOrUpdatedByUser = (query: ISubmissionAnalyticsSearchFilterQuery) =>
  axios.post(`${url}real-time-submission-created-or-updated-by-user`, query);

export const getSubmissionClients = (query: ISubmissionAnalyticsSearchFilterQuery) =>
  axios.post(`${url}real-time-submission-clients`, query);

export const getSubmissionByJobType = (query: ISubmissionAnalyticsSearchFilterQuery) =>
  axios.post(`${url}real-time-submission-by-job-type`, query);

export const getSubmissionByCVSource = (query: ISubmissionAnalyticsSearchFilterQuery) =>
  axios.post(`${url}real-time-submission-by-cv-source`, query);

export const getRealTimeSubmissionTotal = (query: ISubmissionAnalyticsSearchFilterQuery) =>
  axios.post(`${url}real-time-submission-total`, query);

export const getSubmissionHiringPipeline = (query: ISubmissionAnalyticsSearchFilterQuery) =>
  axios.post(`${url}real-time-submission-hiring-pipeline`, query);

export const getSubmissionByTeams = (query: ISubmissionAnalyticsSearchFilterQuery) =>
  axios.post(`${url}real-time-submission-by-teams`, query);

export const getSubmissionByUsers = (query: ISubmissionAnalyticsSearchFilterQuery) =>
  axios.post(`${url}real-time-submission-by-users`, query);

export const getSubmissionAccountManagerTables = (query: ISubmissionAnalyticsSearchFilterQuery) =>
  axios.post(`${url}real-time-submission-account-manager-table`, query);

export const getSubmissionToAccountManagers = (query: ISubmissionAnalyticsSearchFilterQuery) =>
  axios.post(`${url}real-time-submission-to-account-managers`, query);

export const getSubmissionJobsServicedDetails = (query: ISubmissionAnalyticsSearchFilterQuery) =>
  axios.post(`${url}real-time-submission-job-service-details`, query);

export const getSubmissionTotalValue = (query: ISubmissionAnalyticsSearchFilterQuery) =>
  axios.post(`${url}real-time-submission-total-value`, query);

export const getCandidateSubmissionsDetails = (query: ISubmissionAnalyticsSearchFilterQuery) =>
  axios.post(`${url}real-time-submission-candidate-submission-details`, query);

export const getJobsPostedAnalytics = (filter: IJobSearchFilterDTO) =>
  axios.post(`${url}job-posting-analytics-jobs-posted`, filter);

export const getApplicationsReceivedAnalytics = (filter: IJobSearchFilterDTO) =>
  axios.post(`${url}job-posting-analytics-applications-received`, filter);

export const getApplicationInsightsAgg = (filter: IJobCandidateInteraction) =>
  axios.post(`${url}application-analytics-agg`, filter);

export const getKibanaAnalyticsSetting = () => axios.get('api/kibana-analytics-setting');

export const getKibanaWorkspaceAnalytics = () => axios.get('api/kibana/search-workspace');

export const saveKibanaAnalyticsSettings = (payload: IKibanaAnalyticsSettingsPayload) =>
  axios.post('api/kibana-analytics-setting', payload);

export const getWeeklyJobsPostedCount = (payload: IAnalyticsJobSearchFilterDTO) =>
  axios.post(`${url}weekly-jobs-posted`, payload);

export const getWeeklyOpenJobsCount = (payload: IAnalyticsJobSearchFilterDTO) =>
  axios.post(`${url}weekly-open-jobs-count`, payload);

export const getWeeklyClosedJobsCount = (payload: IAnalyticsJobSearchFilterDTO) =>
  axios.post(`${url}weekly-closed-jobs-count`, payload);

export const getJobsMonthlyTrend = (payload: IAnalyticsJobSearchFilterDTO) =>
  axios.post(`${url}jobs/monthly-trend`, payload);

export const getJobsBySubmissionsCount = (payload: IAnalyticsJobSearchFilterDTO) =>
  axios.post(`${url}weekly-jobs-report/jobs-by-submissions-count`, payload);

export const getJobsBySubmissionsCountWithFilters = (payload: IAnalyticsJobSearchFilterDTO) =>
  axios.post(`${url}jobs/submitted-jobs-count-filters`, payload);

export const jobsByAccountManager = (payload: IAnalyticsJobSearchFilterDTO) =>
  axios.post(`${url}jobs/jobs-by-account-manager`, payload);

export const getJobsByType = (payload: IAnalyticsJobSearchFilterDTO) =>
  axios.post(`${url}jobs/jobs-by-type`, payload);

export const getJobsByClient = (payload: IAnalyticsJobSearchFilterDTO) =>
  axios.post(`${url}jobs/jobs-by-client`, payload);

export const getJobsWeeklyTrend = (payload: IAnalyticsJobSearchFilterDTO) =>
  axios.post(`${url}jobs/jobs-weekly-trend`, payload);

export const getJobsByWisestepJobCode = (payload: IAnalyticsJobSearchFilterDTO) =>
  axios.post(`${url}jobs/jobs-by-wisestep-code`, payload);

export const getJobsPostedForHundredDays = (payload: IAnalyticsJobSearchFilterDTO) =>
  axios.post(`${url}jobs/jobs-posted-for-hundred-days`, payload);

export const getMappingStatusTable = (query: ISubmissionAnalyticsSearchFilterQuery) =>
  axios.post(`${url}real-time-mapping-status-table`, query);

export const getRealTimeMappingTrend = (query: ISubmissionAnalyticsSearchFilterQuery) =>
  axios.post(`${url}real-time-mapping-trend`, query);

export const getMappingsRecruiterLevel = (query: ISubmissionAnalyticsSearchFilterQuery) =>
  axios.post(`${url}real-time-mapping-recruiter-level`, query);

export const getMappingByTeams = (query: ISubmissionAnalyticsSearchFilterQuery) =>
  axios.post(`${url}real-time-mapping-by-teams`, query);

export const getMappingByUsers = (query: ISubmissionAnalyticsSearchFilterQuery) =>
  axios.post(`${url}real-time-mapping-by-users`, query);

export const getTeamLevelReport = (query: ISubmissionAnalyticsSearchFilterQuery) =>
  axios.post(`${url}real-time-mapping-team-level`, query);

export const getClientLevelReports = (query: ISubmissionAnalyticsSearchFilterQuery) =>
  axios.post(`${url}real-time-mapping-client-level`, query);

export const getMappingTable = (query: ISubmissionAnalyticsSearchFilterQuery) =>
  axios.post(`${url}real-time-mapping-table`, query);

export const getMappingsByCVSource = (query: ISubmissionAnalyticsSearchFilterQuery) =>
  axios.post(`${url}real-time-mapping-by-cv-source`, query);

export const getMappingsByJobType = (query: ISubmissionAnalyticsSearchFilterQuery) =>
  axios.post(`${url}real-time-mapping-by-job-type`, query);

export const getMappingsByCVSourcePie = (query: ISubmissionAnalyticsSearchFilterQuery) =>
  axios.post(`${url}real-time-mapping-by-cv-source-pie`, query);

export const getCandidateEmailSentData = (query: IEmailAnalyticsFilter) =>
  axios.post(`${url}get-candidate-email-sent-last3months`, query);

export const getCandidateEmailCount = (query: IEmailAnalyticsFilter) =>
  axios.post(`${url}get-candidate-email-count-last3months`, query);

export const getCandidateEmailTrend = (query: IEmailAnalyticsFilter) =>
  axios.post(`${url}get-candidate-email-trend-last3months`, query);

export const getWIPJobAnalytics = (query: IDashboardAnalyticsParams) =>
  axios.post(`${url}dashboard/wip-jobs`, query);

export const getCommunicationMetrics = (query: IDashboardAnalyticsParams) =>
  axios.post(`${url}dashboard/comms-stats`, query);

export const getAIMetrics = (query: IDashboardAnalyticsParams) =>
  axios.post(`${url}dashboard/ai-stats`, query);

export const getBotsMetrics = (query: IDashboardAnalyticsParams) =>
  axios.post(`/candidatesearch/api/harvesting-bot/bots-stats`, query);

export const getMappingTrendAnalytics = (query: IDashboardAnalyticsParams) =>
  axios.post(`${url}dashboard/mapping-trend`, query);

export const getSubmissionTrendAnalytics = (query: IDashboardAnalyticsParams) =>
  axios.post(`${url}dashboard/submission-trend`, query);

export const getUserDashboardRecruiterActivity = (searchFilter: IJobCandidateInteraction) =>
  axios.post(`${url}get-user-dashboard-recruiter-activity`, searchFilter);

export const getUserDashboardTeamActivity = (searchFilter: IJobCandidateInteraction) =>
  axios.post(`${url}get-user-dashboard-team-activity`, searchFilter);

export const getDashboardCandidateStats = (query: IDashboardAnalyticsParams) =>
  axios.post(`${url}dashboard/candidate-stats`, query);

export const getDashboardApplications = (query: IDashboardAnalyticsParams) =>
  axios.post(`${url}dashboard/application`, query);

export const getDashboardMappings = (query: IDashboardAnalyticsParams) =>
  axios.post(`${url}dashboard/mapping`, query);

export const getDashboardMappingPieChartData = (query: IDashboardAnalyticsParams) =>
  axios.post(`${url}dashboard/mapping-pie-chart`, query);

export const getDashboardSubmissions = (query: IDashboardAnalyticsParams) =>
  axios.post(`${url}dashboard/submission`, query);

export const getDashboardUploads = (query: IDashboardAnalyticsParams) =>
  axios.post(`${url}dashboard/upload`, query);

export const getDashboardUploadPieChartData = (query: IDashboardAnalyticsParams) =>
  axios.post(`${url}dashboard/upload-pie-chart`, query);

export const getCandidatePipeline = (query: IDashboardAnalyticsParams) =>
  axios.post(`${url}dashboard/candidate-pipeline`, query);

export const getClientActivity = () => axios.post(`${url}dashboard/client-activity`);

export const getAMActivity = () => axios.post(`${url}dashboard/am-activity`);

export const getSPOCActivity = () => axios.post(`${url}dashboard/spoc-activity`);

export const getSMSSentInLast3Months = (searchFilter: IJobCandidateInteraction) =>
  axios.post(`${url}get-sent-sms-trend-last3months`, searchFilter);

export const getSMSCountInLast3Months = (searchFilter: IJobCandidateInteraction) =>
  axios.post(`${url}get-sms-count-last3months`, searchFilter);

export const getSMSTrendInLast3Months = (searchFilter: IJobCandidateInteraction) =>
  axios.post(`${url}get-sms-trend-by-days`, searchFilter);

export const getFollowupsTrendDataInLast3Months = (searchFilter: ITaskSearchParam) =>
  axios.post(`${url}get-followups-trend-data-last3Months`, searchFilter);

export const getFollowupsTableDataInLast3Months = (searchFilter: ITaskSearchParam) =>
  axios.post(`${url}get-followups-table-data-last3Months`, searchFilter);

export const getFollowupsTrendsDataByDays = (searchFilter: ITaskSearchParam) =>
  axios.post(`${url}get-followups-trends-data-byDays`, searchFilter);

export const getLoginLogoutAnalytics = (payload: ILoginLogoutAnalyticsDTo) =>
  axios.post(`${url}login-logout-analytics/`, payload);

export const getUserCareerActivity = (searchFilter: ISubmissionAnalyticsSearchFilterQuery) =>
  axios.post(`${url}get-user-dashboard-carrer-activity`, searchFilter);
